import { Box, Image, Text } from "@chakra-ui/react";

import { SelfLearnButtonsAccordionStyles } from "./SelfLearnButtonsAccordionStyles";
import accordion_images from "../../../utils/accordion/accordion_images";
import { useRoot } from "../../../context/RootContext";
import { isNotEmptyOrNull } from "../../../utils/common-utils";

//Individual Button
const SelfLearnButton = ({
  label,
  imgSrc,
  onClick,
  isMobile,
  customStyles,
}) => {
  return (
    <Box
      sx={SelfLearnButtonsAccordionStyles(isMobile).selfLearnButton}
      onClick={onClick}
      data-testid={`self-learn-button-${label}`}
    >
      {/* <Image src={imgSrc} sx={customStyles} /> */}
      <Text>{label}</Text>
    </Box>
  );
};

const SelfLearnButtonsAccordion = ({
  isMobile,
  setTaskType,
  onClick,
  topic_feature,
  isChapterEndAssessment,
  isAdvanced,
  isPrerequisite,
}) => {
  const { setIsSelfLearnButtonClick } = useRoot();

  //Button Array for Normal Tasks
  const normalButtons = [
    {
      label: "Assessment Practice",
      imgSrc: accordion_images.assessmentWhite,
      taskType: "assessment",
      clickLabel: "Self Learn",
      enable: isNotEmptyOrNull(topic_feature)
        ? topic_feature?.Assessment?.is_enabled
          ? true
          : false
        : true,
    },
    {
      label: "Guided Practice",
      imgSrc: accordion_images.practiceWhite,
      taskType: "guidedPractise",
      clickLabel: "Self Learn",
      enable: isNotEmptyOrNull(topic_feature)
        ? topic_feature?.GuidedPractice?.is_enabled
          ? true
          : false
        : true,
    },
    {
      label: "Learn",
      imgSrc: accordion_images.learnWhite,
      taskType: "learnSubtopic",
      clickLabel: "Self Learn",
      enable: isNotEmptyOrNull(topic_feature)
        ? topic_feature?.Learn?.is_enabled
          ? true
          : false
        : true,
    },
  ];

  //Button Array for Chapter End Tasks
  const chapterEndButtons = [
    {
      label: "Guided Practice",
      imgSrc: accordion_images.proficiency,
      taskType: "guidedPractise",
      clickLabel: "proficient",
      enable: isNotEmptyOrNull(topic_feature)
        ? topic_feature?.Assessment?.is_enabled
          ? isAdvanced
            ? false
            : true
          : false
        : isAdvanced
        ? false
        : true,
    },
    {
      label: "Assessment Practice",
      imgSrc: isAdvanced
        ? accordion_images.advanced
        : accordion_images.proficiency,
      taskType: "assessment",
      clickLabel: isAdvanced ? "advanced" : "proficient",
      enable: isNotEmptyOrNull(topic_feature)
        ? topic_feature?.Assessment?.is_enabled
          ? true
          : false
        : true,
    },
  ];

  //Button for Prerequisite
  const prerequisiteButton = [
    {
      label: "Prerequisite",
      imgSrc: accordion_images.prerequisiteWhite,
      taskType: "learnPrerequisite",
      clickLabel: "Self Learn",
      enable: isNotEmptyOrNull(topic_feature)
        ? topic_feature?.Prerequisite?.is_enabled
          ? true
          : false
        : true,
    },
  ];

  //buttons to display based on condition
  const buttonsToRender = isChapterEndAssessment
    ? chapterEndButtons
    : isPrerequisite
    ? prerequisiteButton
    : normalButtons;

  return (
    <Box
      data-testid={`self-learn-button`}
      sx={SelfLearnButtonsAccordionStyles(isMobile).mainContainer}
    >
      {buttonsToRender
        .filter((button) => button?.enable)
        .map(({ label, imgSrc, taskType, clickLabel }, index) => (
          <SelfLearnButton
            key={index}
            label={label}
            imgSrc={imgSrc}
            isMobile={isMobile}
            customStyles={
              isChapterEndAssessment
                ? SelfLearnButtonsAccordionStyles(isMobile).ceaSelfLearnImage
                : SelfLearnButtonsAccordionStyles(isMobile).selfLearnImage
            }
            onClick={() => {
              setIsSelfLearnButtonClick(true);
              setTaskType(taskType);
              onClick(clickLabel, isChapterEndAssessment, -1, taskType);
            }}
          />
        ))}
    </Box>
  );
};

export default SelfLearnButtonsAccordion;
